import React,{Component} from 'react';
import {connect} from 'react-redux';
import { confirmAction, showError } from '../../actions/uiActions';
import AuthorizedOfficial from '../../forms/AuthorizedOfficial';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

class PSLFDestinatary extends Component {
    state={
        manual:false,
        entity:null,
        selectedOfficial: null,
        notes: ""
    }
    componentDidMount() {
        const { employer } = this.props;

        if (this.shouldSetManual(employer)) {
            this.setState({ manual: true });
        } else if (this.shouldConfirmDefaultOfficial(employer)) {
            this.confirmDefaultOfficial();
        } else if (this.shouldSetDefaultEntity(employer)) {
            this.setState({ entity: -1 });
        }
    }

    // Helper method to check if manual mode should be set
    shouldSetManual(employer) {
        const hasNoEntities = !employer.entities || employer.entities.length === 0;
        const hasNoOfficials = !employer.officials || (employer.officials || []).length === 0;
        return hasNoEntities && hasNoOfficials;
    }

    // Helper method to check if the default official confirmation is needed
    shouldConfirmDefaultOfficial(employer) {
        const hasOneEntity = employer.entities && employer.entities.length === 1;
        const hasOfficials = employer.officials && (employer.officials || []).length > 0;
        return hasOneEntity && hasOfficials;
    }

    // Helper method to check if default entity should be set
    shouldSetDefaultEntity(employer) {
        return !employer.entities || employer.entities.length === 0;
    }

    // Helper method to handle default official confirmation
    confirmDefaultOfficial() {
        this.props.confirmAction(
            "The referral company of this user has a default Authorized Official for PSLF Employment Certification. Do you want to send this form to the default Authorized Official?",
            () => this.setState({ entity: -1 }),
            "Indicate Destinatary",
            "Send to default Official",
            "Enter Official's Information",
            () => this.setState({ manual: true })
        );
    }

    getOfficials = () => {
        const entity=(this.props.employer.entities ?? []).find(e=>e.id===this.state.entity);
        const officials=[{
            ...entity,
            official_name:entity.official_name,
            official_email:entity.official_email,
            official_title:entity.official_title,
            official_phone:entity.official_phone,
            official_remarks:entity.official_remarks,
            attachments:entity.documents||[],
            
        }];
        if(entity.officials) {
            entity.officials.forEach((official)=>{
                officials.push({
                    ...entity,
                    ...official,
                    attachments:this.props.employer.documents||[]
                })
            })
        }
        return officials;
    }
    getEntities=()=>{
        const entities = [];
        if(this.props.employer.entities) {
            this.props.employer.entities.forEach(entity=>{
                entities.push({
                    id:entity.id,
                    name:entity.employer_name,
                    fein:entity.employer_fein
    
                })
            })
        }
        return entities;
    }


    selectOfficial = (official) => {
        const selectedField = {
            employer_name: official.employer_name,
            employer_fein: official.employer_fein,
            employer_website: official.employer_website,
            employer_official_name: official.official_name,
            employer_official_email: official.official_email,
            employer_official_phone: official.official_phone,
            official_title: official.official_title,
            employer_address: official?.employer_address || '',
            id: official.id,
            domainId: this.props.domainId
        }
        this.setState({selectedOfficial:selectedField})
    }

    handleEmployer() {
        if (!this.state.selectedOfficial) {
            return this.props.showError("Please select the entity field")
        }
        this.props.onConfirm(this.state.notes, this.state.selectedOfficial)
        
    }

    renderOfficialSelection = () => {
        const officials = this.getOfficials();
        if (!this.state.selectedOfficial) {
            this.selectOfficial(officials[0])
        }
        return <Dialog  aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description" open={true}
            maxWidth="sm" fullWidth={true}><DialogTitle id="alert-dialog-title">Select Authorized Official</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
            <p>
                Select the authorized official from {this.props.employer.company} that will sign this form.
            </p>
            <ul className="officials-list">
            {officials.map((official,index)=>
                <li className={official.id === this.state.selectedOfficial?.id ? "official_active" : ""}
                    key={`official-${index}`} onClick={() => this.selectOfficial(official)} style={{border:"none"}}>
                <div className="name">
                    {official.official_name}
                </div>
                <div className="remarks">
                    {official.official_remarks}
                </div>
                </li>)}
                    </ul>
                <div className="form-group nice" style={{marginTop:"12px"}}>
                    <label>Message:</label>
                    <textarea onChange={(e) => this.setState({notes: e.target.value})} type="text" col="4" placeholder={`Enter any additional notes for the Authorized Official (e.g. "Please certify my employment with Company ABC from Dec 2019 to February 2021" )`} className="form-control" value={this.state.notes} name="notes" />
                </div>

                </DialogContentText>
            </DialogContent>
            <DialogActions>
        <Button onClick={() => this.handleEmployer()}>
            Assign Employer
          </Button>
          <Button onClick={this.props.onCancel} color="primary">
            Cancel
          </Button>
        </DialogActions></Dialog>
    }
    renderEntitySelection=()=>{
        const entities=this.getEntities();
        return <><DialogTitle id="alert-dialog-title">Select The Employer Entity</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p>
                Select the entity from {this.props.employer.company} of the authorized official that will sign this form.
            </p>
            <ul className="officials-list">
            {entities.map((entity,index)=><li onClick={()=>this.setState({entity:entity.id})} key={`entity-${index}`}>
                <div className="entity">
                    {entity.name}
                </div>
                <div className="fein">
                    {entity.fein}
                </div>
            </li>)}
            </ul>
            
            
            
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button onClick={()=>this.setState({manual:true})} >
            Enter Manually
          </Button>
          <Button onClick={this.props.onCancel} color="primary">
            Cancel
          </Button>
        </DialogActions></>
    }
    render() {
        const { manual, entity } = this.state;
        const { employer, note, onCancel, onConfirm } = this.props;

        // Render the dialog for entity or official selection
        const hasEntities = employer.entities && employer.entities.length > 0;
        const hasOfficials = employer.officials && employer.officials.length > 0;

        if(manual) {
            return <AuthorizedOfficial note={this.props.note} onCancel={this.props.onCancel} onConfirm={this.props.onConfirm} />
        } else if (entity || entity === -1) {
            return this.renderOfficialSelection();
        } else if (hasEntities || hasOfficials) {
            return (
                <Dialog
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    open={true}
                    maxWidth="sm"
                    fullWidth={true}
                >
                    {!entity ? this.renderEntitySelection() : <></>}
                </Dialog>
            );
        }
    }
}
export default connect(null,{confirmAction, showError})(PSLFDestinatary);